import React, { Fragment } from 'react'
import {
    List,
    Datagrid,
    NumberField,
    TextField,
    EmailField,
    BooleanField
    // ReferenceField,
} from 'react-admin'

import Title from '../Generic/Title'
import { PermisoField } from '../Permiso'

// import { rolesChoices } from './data.js'

export const UsuarioCoordinadoList = ({ permissions, ...props }) => {
    if (permissions === null) {
        return null
    }
    // const role = permissions.role
    return (
        <Fragment>
            <Title title={"Usuarios Coordinados"} />
            <List {...props} exporter={false} >
                <Datagrid rowClick="edit">
                    <NumberField source="id" />
                    <TextField source="first_name" label="Nombre"/>
                    <TextField source="last_name" label="Apellido"/>
                    <TextField source="username" />
                    <EmailField source="email" />
                    {/* <ReferenceField source="empresa" reference="empresas" allowEmpty>
                        <TextField source="name" />
                    </ReferenceField> */}
                    <PermisoField source="permissions" label="Permisos"/>
                    <BooleanField source="is_active" label="Estado"/>
                </Datagrid>
            </List>
        </Fragment>
    )
}
